import React, { useMemo } from 'react'
import { Access } from "./ProductAccessDetails.types"
import { Checkbox } from '@gf-easy-8/grmnext-foundation'

type SubAccessProps = {
  subAccess: Access
  subAccessKey: number
  selectedProductRoleAccessIds: string[]
  onToggleChange: (productRoleAccessId: string, accesses?: Access[]) => () => void  
  hasFullAccess: boolean

  //parent
  parentKey: number
  parentProductRoleAccessId: string
}

const SubAccess: React.FC<SubAccessProps> = ({subAccess, subAccessKey, selectedProductRoleAccessIds, onToggleChange, hasFullAccess, parentKey, parentProductRoleAccessId }) => {

  // recursive rendering for nested subAccesses
  let nestedSubAccessList: React.ReactNode[] = []
  if (Array.isArray(subAccess?.subAccesses) && subAccess.subAccesses.length > 0) {
    nestedSubAccessList = subAccess.subAccesses.map((nestedSubAccess: Access, nestedSubAccessKey: number) => (
      <SubAccess
        subAccess={nestedSubAccess}
        subAccessKey={nestedSubAccessKey}
        selectedProductRoleAccessIds={selectedProductRoleAccessIds}
        onToggleChange={onToggleChange}
        hasFullAccess={hasFullAccess}
        parentKey={parentKey}
        parentProductRoleAccessId={subAccess.productRoleAccessId}
      />
    ))
  }
  
  // disable subAccess checkbox if parent is not selected or no full access
  const isDisabled = useMemo(() => {
    const isParentSelected = selectedProductRoleAccessIds.includes(parentProductRoleAccessId)
    return !hasFullAccess || !isParentSelected
  }, [subAccess, hasFullAccess, selectedProductRoleAccessIds, parentProductRoleAccessId])

  return (
    <>
      <Checkbox
        key={`productSubAccessCheckBoxContianer${parentKey}-${subAccessKey}`}
        label={subAccess.accessName}
        value={
          selectedProductRoleAccessIds.includes(
            subAccess.productRoleAccessId
          )
            ? "checked"
            : "unchecked"
        }
        onChange={onToggleChange(
          subAccess.productRoleAccessId,
          subAccess.subAccesses ?? []
        )}
        disabled={isDisabled}
      />
      {nestedSubAccessList}
    </>
  )
}

export default SubAccess
